import Vue from 'vue'
import VueI18n from 'vue-i18n'


import zhCN from './locales/zh_CN'
import zhTW from './locales/zh_TW'
import en from './locales/en'


Vue.use(VueI18n)


const messages = {

  zh_CN: zhCN,

  zh_TW: zhTW,

  en: en

}



// 获取手机系统语言
function getSystemLocale(){


  let lang = ''


  // 手机浏览器
  if(navigator.language){

    lang = navigator.language

  }
  else if(navigator.userLanguage){

    lang = navigator.userLanguage

  }



  console.log('手机语言:',lang)



  switch(lang){


    // 台湾、香港繁体
  case 'zh-TW':
  case 'zh-HK':
  case 'zh-MO':

    return 'zh_TW';



    // 英文
    case 'en':

    case 'en-US':

    case 'en-GB':

      return 'en'



    // 默认中文
    default:

      return 'zh_CN'

  }


}



const i18n = new VueI18n({

  // 自动检测
  locale:  getSystemLocale(),


  // 找不到语言使用中文
  fallbackLocale:'zh_CN',


  messages

})



export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js